import { apiGet, apiPost, API_URI, MainDomain, apiPostAnon } from "api";
import { ContactShortType } from "types";

const user = {
    login: async (email: string, password: string) => {
        const data = await apiPostAnon(`https://crm-api.${MainDomain}.co.za/api/user/login?email=${email}&password=${password}`);
        // const data = await apiPost(`https://crm-api.amasocial.co.za/api/user/login?email=${email}&password=${password}`);
        return data;
    },
    getById: async (id: number): Promise<ContactShortType> => {
        const data = await apiGet(`https://crm-api.${MainDomain}.co.za/api/user/get?id=${id}`);
        return data;
    },
    setPassword: async (id: number, password: string) => {
        const data = await apiPost(`https://crm-api.${MainDomain}.co.za/api/user/password/set`, {
            IDUser: id,
            Password: password,
            PasswordConfirm: password,
        });
        return data;
    },
    get: async () => {
        // const data = await apiGet(`${API_URI}/api/user/get`);
        const data = await apiGet(`https://crm-api.${MainDomain}.co.za/api/user/v2/get`);
        // const data = await apiGet(`https://api.amasocial.co.za/api/user/get`);
        return data;
    },
    ticket: {
        getAll: async (clientId: number) => {
            const data = await apiGet(`${API_URI}/api/contact/ticket?clientId=${clientId}`);
            return data;
        },
    },
    forgotPassword: async (email: string) => {
        const data = await apiPost(`${API_URI}/api/user/forgotpassword?email=${email}&system=${MainDomain}`);
        return data;
    },
};

export default user;
